import React from 'react'
import Footer from '../../Footer'
import bg from '../../../img/id/game/bg.png'
import logo from '../../../img/id/game/logo.png'
import fig1 from '../../../img/id/game/1.png'
import fig2 from '../../../img/id/game/2.png'
import fig3 from '../../../img/id/game/3.png'
import '../Proj.css'

export default class ProjGame extends React.Component{
    render(){
        return(
            <div className="proj-wrapper">
                <div id='game-title'>
                    <img src={logo} />
                    <h1>Game Controller Design</h1>
                    <p>Under supervision of Prof. Shih-Hsu Lin.</p>
                </div>
                <div className='proj-bg' id='game-bg'>
                    <img src={bg} />
                </div>
        
                <div className='proj-fig1'>
                    <img src={fig1} />
                </div>
                <p className='little-title'>Modeling</p>
                <p>
                When a game controller is not in use, it should still be a piece of art that can be placed in the room and proposing an atmosphere of joyfulness. This is why JOEED has a shape that can be seen as a loop or a surface, and can be placed in various directions. When it is used, it works smoothly in hand. But when it is idled, it is a decoration that has vivid color and interesting geometry that can be easily placed on the table.
                </p>
                <div className='proj-content'>
                    <div className='proj-side2side'>
                        <div className='proj-fig'>
                            <img src={fig2} />
                        </div>
                        <p className='little-title'>Inspiration</p>
                        <p>
                        Throughout the designing process, I came across about ten different designs (presented on the upper part of the image above), narrowed them down to the two most interesting ones, and combined them to form the mock-up presented on the right.
                        </p>
                    </div>
                    <div className='proj-side2side'>
                        <div className='proj-fig'>
                            <img src={fig3} />
                        </div>
                        <p className='little-title'>Mock-up Making</p>
                        <p>
                        The mock-up is made of EK foam and modeling clay to explore the geometry and the human factor of using it. After inviting some friends to try to hold it and give comments, the mock-up model is modified, and I moved on to making the final model with Expoxy tooling board and Polyurathane.
                        </p>
                    </div>
                </div>
                <Footer back={true}/>
            </div>
        )
    }
}